<template>
    <p>{{ date(params.value) | date(true) }}</p>
</template>

<script>
export default {
  name: 'CellRendererDate',
  computed: {
    date () {
      return (value) => {
        return value
      }
    }
  }
}
</script>

